module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-text",
    class: [_vm.type ? 'mt-color-' + _vm.type : 'mt-color-grey'],
    style: (_vm.computeStyle),
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.wordwrap) ? _c('pre', [_vm._t("default")], 2) : _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9a4624a","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/text/src/text.vue
// module id = 436
// module chunks = 0